import React, { Fragment, useState, useEffect, useMemo, useRef } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Switch from '@material-ui/core/Switch'
import { Check } from 'react-feather';
import { IMAGE_SLOT_META, MAX_IMAGE_SIZE_BYTES, createEmptyImageSlots } from './imageSlots';

const FormularioProducto = ({ datos, setDatos, actualizar, imagenes = [], onImagenChange }) => {
    const fileInputRefs = useRef({});
    const normalizedSlots = useMemo(() => {
        if (Array.isArray(imagenes) && imagenes.length) {
            return IMAGE_SLOT_META.map(meta => {
                const existing = imagenes.find(slot => slot.order === meta.order);
                if (existing) return { ...meta, ...existing };
                const fallback = createEmptyImageSlots()[meta.order];
                return { ...meta, ...fallback };
            });
        }
        return createEmptyImageSlots();
    }, [imagenes]);

    const portadaSlot = normalizedSlots[0];
    const detalleSlots = normalizedSlots.slice(1);

    const notifyImagenChange = (order, payload) => {
        if (typeof onImagenChange === 'function') {
            onImagenChange(order, payload);
        }
    }

    const handleFile = (order, file) => {
        if (!file) return;

        if (file.size > MAX_IMAGE_SIZE_BYTES) {
            alert("El archivo excede el límite de 80kb permitido.");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            notifyImagenChange(order, {
                base64: reader.result,
                preview: reader.result,
                fileName: file.name,
                remoteUrl: ''
            });
        };
        reader.readAsDataURL(file);
    };

    const onDrop = (order, e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFile(order, file);
    };

    const openFileDialog = (order) => {
        const input = fileInputRefs.current[order];
        if (input) {
            input.value = '';
            input.click();
        }
    }

    const numeros = e => (e.keyCode == (8 || 46) || e.key == 'Tab') ? true : (e.keyCode == (32) || isNaN(e.key)) && e.preventDefault()
    const actProducto = (e) => setDatos({ ...datos, [e.target.name]: (e.target.value) })
    const [departamentos, setDepartamentos] = useState([]);
    const [subdepartamentos, setSubdepartamentos] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const normalizarNombre = (valor) => typeof valor === 'string' ? valor.trim().toLowerCase() : '';
    const filtrarActivos = (lista) => {
        if (!Array.isArray(lista)) return [];
        return lista.filter(item => {
            const estado = item?.ACTIVO;
            if (typeof estado === 'number') return estado === 1;
            if (typeof estado === 'string') return estado.trim() === '1';
            if (typeof estado === 'boolean') return estado === true;
            return false;
        });
    };
    const filtrarUnidadesActivas = (lista) => {
        if (!Array.isArray(lista)) return [];
        return lista.filter(item => {
            const estado = item?.ACTIVO_U ?? item?.ACTIVO ?? item?.activo;
            if (typeof estado === 'number') return estado === 1;
            if (typeof estado === 'string') return estado.trim() === '1';
            if (typeof estado === 'boolean') return estado === true;
            return false;
        });
    };

    const boolVal = (val) => {
        if (typeof val === 'boolean') return val
        if (typeof val === 'number') return val === 1
        if (typeof val === 'string') {
            const normalized = val.trim().toLowerCase()
            return normalized === '1' || normalized === 'true' || normalized === 'si' || normalized === 's├¡'
        }
        return false
    }
    const toggleBool = (field) => setDatos({ ...datos, [field]: !boolVal(datos[field]) })
    
    const getNombreNivel = (idNivel) => {
        if (!Array.isArray(niveles) || niveles.length === 0) {
            return `Nivel ${idNivel}`;
        }
        
        const nivel = niveles.find(n => {
            const id = n.ID_NV || n.ID || n.id || n.ID_NVL || n.id_nvl;
            return Number(id) === Number(idNivel);
        });
        
        if (nivel) {
            return nivel.NOMBRE || nivel.nombre || nivel.Nombre || `Nivel ${idNivel}`;
        }
        
        return `Nivel ${idNivel}`;
    }
    const resolveSustitutosActivo = (raw) => {
        if (Array.isArray(raw)) return raw.length > 0
        if (typeof raw === 'string') {
            const trimmed = raw.trim().toLowerCase()
            if (!trimmed) return false
            return !['0', 'false', 'no'].includes(trimmed)
        }
        return boolVal(raw)
    }

    const shouldShowDiasPedido = boolVal(datos.sobrepedido)
    const [productos, setProductos] = useState([]);
    const [loadingProductos, setLoadingProductos] = useState(false);
    const [sustitutosActivo, setSustitutosActivo] = useState(() => resolveSustitutosActivo(datos?.sustitutos));
    const [precioActivo, setPrecioActivo] = useState(false);
    
    const handlePrecioChange = (e) => {
        let value = e.target.value;
        // Permitir solo números y un punto decimal
        if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
            setDatos({ ...datos, price: value });
        }
    };

    const [filtroTexto, setFiltroTexto] = useState('');
    const [filtroDepartamento, setFiltroDepartamento] = useState('');
    const [filtroSubdepartamento, setFiltroSubdepartamento] = useState('');
    const [pagina, setPagina] = useState(1);
    const pageSize = 10;
    const [niveles, setNiveles] = useState([]);


    useEffect(() => {
        fetch('/p_grupo_select', { headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                setDepartamentos(filtrarActivos(res[0]))
                setSubdepartamentos(filtrarActivos(res[1]))
                setMarcas(filtrarActivos(res[2]))
            })
            .catch(err => console.log('Error: ' + err))
        
        fetch('/p_niveles', { headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                setNiveles(Array.isArray(res) ? res : []);
            })
            .catch(err => console.log('Error cargando niveles: ' + err))

        fetch('/p_unidades', { headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                setUnidades(filtrarUnidadesActivas(res));
            })
            .catch(err => console.log('Error cargando unidades: ' + err))
    }, []);
    const departamentoSeleccionadoId = useMemo(() => {
        const nombreSeleccionado = normalizarNombre(datos.categoria);
        if (!nombreSeleccionado || !Array.isArray(departamentos)) return null;
        const encontrado = departamentos.find(dep => normalizarNombre(dep.NOMBRE) === nombreSeleccionado);
        return encontrado?.ID ?? null;
    }, [datos.categoria, departamentos]);
    const subdepartamentosFiltrados = useMemo(() => {
        if (!Array.isArray(subdepartamentos)) return [];
        if (!departamentoSeleccionadoId) return subdepartamentos;
        return subdepartamentos.filter(sub => {
            if (sub.ID_DEP == null) return false;
            return Number(sub.ID_DEP) === Number(departamentoSeleccionadoId);
        });
    }, [subdepartamentos, departamentoSeleccionadoId]);
    useEffect(() => {
        const subActual = normalizarNombre(datos.subcategoria);
        if (!subActual) return;
        if (!Array.isArray(subdepartamentos) || subdepartamentos.length === 0) return;
        const existe = subdepartamentosFiltrados.some(sub => normalizarNombre(sub.NOMBRE) === subActual);
        if (!existe) {
            setDatos(prev => ({ ...prev, subcategoria: '' }));
        }
    }, [subdepartamentosFiltrados, subdepartamentos, datos.subcategoria, setDatos]);

    useEffect(() => {
        setPagina(1);
    }, [filtroTexto, filtroDepartamento, filtroSubdepartamento]);

    useEffect(() => {
        setSustitutosActivo(resolveSustitutosActivo(datos?.sustitutos));
    }, [datos?.sustitutos]);

    useEffect(() => {
        // Inicializar el slider de precio basado solo en PRECIO_ACTIVO
        setPrecioActivo(boolVal(datos?.PRECIO_ACTIVO));
    }, [datos?.PRECIO_ACTIVO]);

    useEffect(() => {
        let activo = true;
        setLoadingProductos(true);
        fetch('/p_productos', { headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                if (activo) {
                    setProductos(Array.isArray(res) ? res : []);
                    setLoadingProductos(false);
                }
            })
            .catch(err => {
                console.log('Error: ' + err);
                if (activo) {
                    setLoadingProductos(false);
                }
            })
        return () => { activo = false; }
    }, []);

    const sustitutoOptions = useMemo(() => {
        return Array.isArray(productos) ? productos : [];
    }, [productos]);

    const getSku = (prod) => prod?.sku ?? prod?.SKU ?? prod?.codigo ?? prod?.CODIGO ?? '';
    const getNombre = (prod) => prod?.name ?? prod?.NOMBRE ?? prod?.nombre ?? '';
    const getMarca = (prod) => prod?.marca ?? prod?.MARCA ?? '';
    const getUnidad = (prod) => prod?.MIN_UNIDAD ?? prod?.MAX_UNIDAD ?? prod?.unidad ?? prod?.UNIDAD ?? prod?.qty ?? prod?.QTY ?? '';
    const getTipoUnidad = (unidad) => {
        const tipo = unidad?.TIPO_U ?? unidad?.tipo ?? unidad?.TIPO;
        const parsed = Number(tipo);
        return Number.isNaN(parsed) ? null : parsed;
    };
    const getUnidadNombre = (unidad) => unidad?.NOMBRE_U ?? unidad?.nombre ?? unidad?.NOMBRE ?? '';
    const getUnidadKey = (unidad) => String(getUnidadNombre(unidad)).trim().toLowerCase();
    const getCategoria = (prod) => prod?.categoria ?? prod?.CATEGORIA ?? '';
    const getSubcategoria = (prod) => prod?.subcategoria ?? prod?.SUBCATEGORIA ?? '';


    const sustitutosGuardados = useMemo(() => {
        const raw = datos && datos.sustitutos;
        if (Array.isArray(raw)) {
            return raw.map(item => String(item || '').trim()).filter(Boolean);
        }
        if (typeof raw === 'string' && raw.trim().length) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    return parsed.map(item => String(item || '').trim()).filter(Boolean);
                }
            } catch {
                return raw.split(',').map(v => v.trim()).filter(Boolean);
            }
        }
        return [];
    }, [datos.sustitutos]);

    const selectedSustitutos = useMemo(() => {
        if (!sustitutosGuardados.length) return [];
        const lookup = new Map(sustitutoOptions.map(prod => [String(getSku(prod)), prod]));
        return sustitutosGuardados.map(sku => {
            const normalizedSku = String(sku);
            return lookup.get(normalizedSku) || { sku: normalizedSku, name: normalizedSku };
        }).filter(Boolean);
    }, [sustitutosGuardados, sustitutoOptions]);
    const departamentosDisponibles = useMemo(() => {
        return Array.isArray(departamentos) ? departamentos.map(dep => String(dep.NOMBRE || '').trim()).filter(Boolean) : [];
    }, [departamentos]);

    const unidadesActivas = useMemo(() => Array.isArray(unidades) ? unidades : [], [unidades]);
    const unidadesMenudeo = useMemo(() => unidadesActivas.filter(u => getTipoUnidad(u) === 1), [unidadesActivas]);
    const getDatoUnidad = (field) => {
        const value = datos?.[field] ?? datos?.[field?.toLowerCase()] ?? '';
        return String(value || '').trim();
    };
    const unidadPrincipalNombre = getDatoUnidad('MAX_UNIDAD') || String(datos?.unidad || '').trim() || getDatoUnidad('MIN_UNIDAD');
    const unidadPrincipalSeleccionada = useMemo(() => {
        const key = unidadPrincipalNombre.toLowerCase();
        if (!key) return [];
        const match = unidadesActivas.find(u => getUnidadKey(u) === key);
        return match ? [match] : [];
    }, [unidadPrincipalNombre, unidadesActivas]);
    const unidadMenudeoSeleccionada = useMemo(() => {
        const key = getDatoUnidad('MIN_UNIDAD').toLowerCase();
        if (!key) return [];
        const match = unidadesMenudeo.find(u => getUnidadKey(u) === key);
        return match ? [match] : [];
    }, [unidadesMenudeo, datos]);
    const tipoUnidadSeleccionada = unidadPrincipalSeleccionada[0] ? getTipoUnidad(unidadPrincipalSeleccionada[0]) : null;

    useEffect(() => {
        // Solo permitimos capturar cantidad cuando la unidad principal es mayoreo.
        // Evita limpiar al cargar mientras todavía no se resuelve el tipo de unidad.
        if (tipoUnidadSeleccionada == null || tipoUnidadSeleccionada === 2) return;
        const qtyActual = String(datos?.MIN_UNIDAD_QTY ?? '').trim();
        if (qtyActual !== '') {
            setDatos(prev => ({ ...prev, MIN_UNIDAD_QTY: '' }));
        }
    }, [tipoUnidadSeleccionada, datos?.MIN_UNIDAD_QTY, setDatos]);

    const subdepartamentosDisponibles = useMemo(() => {
        const base = Array.isArray(subdepartamentos) ? subdepartamentos : [];
        if (!filtroDepartamento) {
            return base.map(sub => String(sub.NOMBRE || '').trim()).filter(Boolean);
        }
        const depNombre = String(filtroDepartamento).trim().toLowerCase();
        const depMatch = departamentos.find(dep => String(dep.NOMBRE || '').trim().toLowerCase() == depNombre);
        if (!depMatch) return base.map(sub => String(sub.NOMBRE || '').trim()).filter(Boolean);
        return base.filter(sub => Number(sub.ID_DEP) === Number(depMatch.ID)).map(sub => String(sub.NOMBRE || '').trim()).filter(Boolean);
    }, [subdepartamentos, departamentos, filtroDepartamento]);

    const productosFiltrados = useMemo(() => {
        const base = Array.isArray(productos) ? productos : [];
        const texto = String(filtroTexto || '').trim().toLowerCase();
        const depFiltro = String(filtroDepartamento || '').trim().toLowerCase();
        const subFiltro = String(filtroSubdepartamento || '').trim().toLowerCase();

        return base.filter(prod => {
            const sku = String(getSku(prod)).trim().toLowerCase();
            const nombre = String(getNombre(prod)).trim().toLowerCase();
            const categoria = String(getCategoria(prod)).trim().toLowerCase();
            const subcategoria = String(getSubcategoria(prod)).trim().toLowerCase();

            if (texto && !(sku.includes(texto) || nombre.includes(texto) || categoria.includes(texto) || subcategoria.includes(texto))) {
                return false;
            }
            if (depFiltro && categoria !== depFiltro) return false;
            if (subFiltro && subcategoria !== subFiltro) return false;
            return true;
        });
    }, [productos, filtroTexto, filtroDepartamento, filtroSubdepartamento]);

    const totalPaginas = Math.max(1, Math.ceil(productosFiltrados.length / pageSize));
    const paginaActiva = Math.min(Math.max(pagina, 1), totalPaginas);
    const productosPaginados = useMemo(() => {
        const start = (paginaActiva - 1) * pageSize;
        return productosFiltrados.slice(start, start + pageSize);
    }, [productosFiltrados, paginaActiva, pageSize]);

    const toggleSustituto = (prod) => {
        const sku = String(getSku(prod) || '').trim();
        if (!sku) return;
        const actual = sustitutosGuardados;
        const existe = actual.some(item => String(item) === sku);
        const siguiente = existe
            ? actual.filter(item => String(item) !== sku)
            : [...actual, sku];
        setDatos({ ...datos, sustitutos: siguiente });
    };

    const showSustitutosTable = sustitutosActivo

    const styles = {
        headerItem: { display: 'flex', alignItems: 'center', marginBottom: '15px' },
        iconCircle: {
            width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#000082',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', marginRight: '12px'
        },
        headerTitle: { fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: '0' },
        headerSub: { fontSize: '11px', color: '#888' },
        dropzone: {
            border: '2px dashed #000082', borderRadius: '10px', padding: '40px',
            textAlign: 'center', cursor: 'pointer', transition: '0.3s',
			backgroundColor: 'rgba(0, 0, 130, 0.2)', flex: ' 1 1 auto', position: 'relative'
        },
        dropzoneMiniatura: {
            border: '2px dashed #000082', borderRadius: '10px', padding: '40px',
            textAlign: 'center', cursor: 'pointer', transition: '0.3s',
			backgroundColor: 'rgba(0, 0, 130, 0.2)', width: '23.9%', position: 'relative'
        },
        browseText: { color: '#000082', fontWeight: 'bold', textDecoration: 'underline' },
        deleteButton: {
            position: 'absolute',
            top: '10px',
            right: '10px',
            width: '26px',
            height: '26px',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: '#fff',
            color: '#ff351e',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            zIndex: 2,
            lineHeight: '1'
        }
    };

    const clearSlot = (order, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        notifyImagenChange(order, {
            base64: '',
            preview: '',
            fileName: '',
            remoteUrl: ''
        });
    };

    const shouldShowDeleteButton = (slot) =>
        Boolean(slot && (slot.preview || slot.base64 || slot.remoteUrl));

    const renderDeleteButton = (slot) => {
        if (!shouldShowDeleteButton(slot)) return null;
        return (
            <button
                type="button"
                style={styles.deleteButton}
                onClick={(e) => clearSlot(slot.order, e)}
                aria-label="Eliminar imagen"
            >
                ×
            </button>
        );
    };

    return (
        <Fragment>
            <h4 className="mt-3 ml-4"><strong>{!actualizar ? 'Agregar' : 'Actualizar'} Producto</strong></h4>
            <div className="card-body">
                <div className="row">
					<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>SKU*</label>
								<input name={`sku`} value={datos.sku} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Nombre*</label>
								<input name={`name`} value={datos.name} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Descripción*</label>
								<input name={`description`} value={datos.description} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Descripción Corta*</label>
								<input name={`short_description`} value={datos.short_description} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<label className={`form-label`}>Departamento*</label>
							<div className="form-group">
                        	    <Typeahead
                        	        id="basic-typeahead"
                        	        labelKey="NOMBRE"
                        	        options={departamentos}
                        	        placeholder="Departamento..."
									clearButton
									paginate={false}
									maxResults={600}
									selected={departamentos.filter(dep => normalizarNombre(dep.NOMBRE) === normalizarNombre(datos.categoria))}
									onChange={val=>setDatos({ ...datos, categoria:val.length==0?'':val[0].NOMBRE})}
                        	    />
                        	</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Subdepartamento</label>
                                <Typeahead
                        	        id="basic-typeahead"
                        	        labelKey="NOMBRE"
                        	        options={subdepartamentosFiltrados}
									paginate={false}
									maxResults={600}
                        	        placeholder="Subepartamento..."
									clearButton
									selected={subdepartamentosFiltrados.filter(sub => normalizarNombre(sub.NOMBRE) === normalizarNombre(datos.subcategoria))}
									onChange={val=>setDatos({ ...datos, subcategoria:val.length==0?'':val[0].NOMBRE})}
                        	    />
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Marca*</label>
								<Typeahead
                        	        id="basic-typeahead"
                        	        labelKey="NOMBRE"
                        	        options={marcas}
									paginate={false}
									maxResults={600}
                        	        placeholder="Subepartamento..."
									clearButton
									selected={marcas.filter(mar => normalizarNombre(mar.NOMBRE) === normalizarNombre(datos.marca))}
									onChange={val=>setDatos({ ...datos, marca:val.length==0?'':val[0].NOMBRE})}
                        	    />
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Material</label>
								<input name={`material`} value={datos.material} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Color</label>
								<input name={`color`} value={datos.color} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Acabado</label>
								<input name={`acabado`} value={datos.acabado} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Medida</label>
								<input name={`medida`} value={datos.medida} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Tipo</label>
								<input name={`tipo`} value={datos.tipo} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Funcionamiento</label>
								<input name={`funcionamiento`} value={datos.funcionamiento} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Potencia</label>
								<input name={`potencia`} value={datos.potencia} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Uso</label>
								<input name={`uso`} value={datos.uso} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Largo</label>
								<input name={`largo`} value={datos.largo} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Largo máximo</label>
								<input name={`largo_maximo`} value={datos.largo_maximo} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Ancho</label>
								<input name={`ancho`} value={datos.ancho} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Altura</label>
								<input name={`altura`} value={datos.altura} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Diametro</label>
								<input name={`diametro`} value={datos.diametro} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>

						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Unidad*</label>
                                <Typeahead
                                    id="unidad-typeahead"
                                    labelKey="NOMBRE_U"
                                    options={unidadesActivas}
                                    placeholder="Unidad..."
                                    clearButton
                                    paginate={false}
                                    maxResults={600}
                                    selected={unidadPrincipalSeleccionada}
                                    onChange={(val) => {
                                        const selected = Array.isArray(val) && val.length ? val[0] : null;
                                        if (!selected) {
                                            setDatos(prev => ({
                                                ...prev,
                                                unidad: '',
                                                MIN_UNIDAD: '',
                                                MAX_UNIDAD: '',
                                                MIN_UNIDAD_QTY: ''
                                            }));
                                            return;
                                        }
                                        const nombre = getUnidadNombre(selected);
                                        const tipo = getTipoUnidad(selected);
                                        if (tipo === 2) {
                                            setDatos(prev => ({
                                                ...prev,
                                                unidad: nombre,
                                                MAX_UNIDAD: nombre,
                                                MIN_UNIDAD: '',
                                                MIN_UNIDAD_QTY: ''
                                            }));
                                        } else {
                                            setDatos(prev => ({
                                                ...prev,
                                                unidad: nombre,
                                                MIN_UNIDAD: nombre,
                                                MAX_UNIDAD: '',
                                                MIN_UNIDAD_QTY: ''
                                            }));
                                        }
                                        // Lógica deshabilitada por solicitud:
                                        // cuando la unidad principal es de menudeo no se habilita
                                        // la selección de una unidad de mayoreo relacionada.
                                        // Se mantiene únicamente el flujo:
                                        // unidad principal mayoreo -> unidad relacionada menudeo.
                                    }}
                                />
							</div>
						</div>
                        {(tipoUnidadSeleccionada === 2) && (
                        <Fragment>
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label className={`form-label`}>
                                        {'Maximo unidades menudeo por mayoreo'}
                                    </label>
                                    <input
                                        name="MIN_UNIDAD_QTY"
                                        value={datos.MIN_UNIDAD_QTY ?? ''}
                                        className="form-control"
                                        type="number"
                                        min={1}
                                        step={1}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setDatos(prev => ({ ...prev, MIN_UNIDAD_QTY: value }));
                                        }}
                                        onKeyDown={numeros}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label className={`form-label`}>
                                        {'Unidad menudeo'}
                                    </label>
                                    <Typeahead
                                        id="unidad-menudeo-typeahead"
                                        labelKey="NOMBRE_U"
                                        options={unidadesMenudeo}
                                        placeholder="Unidad menudeo..."
                                        clearButton
                                        paginate={false}
                                        maxResults={600}
                                        selected={unidadMenudeoSeleccionada}
                                        onChange={(val) => {
                                            const selected = Array.isArray(val) && val.length ? val[0] : null;
                                            const nombre = selected ? getUnidadNombre(selected) : '';
                                            setDatos(prev => ({ ...prev, MIN_UNIDAD: nombre }));
                                        }}
                                    />
                                </div>
                            </div>
                        </Fragment>
                        )}
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Contenido</label>
								<input name={`contenido`} value={datos.contenido} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group">
								<label className={`form-label`}>Oferta</label>
								<input name={`oferta`} value={datos.oferta} className={`form-control`} type="text" onChange={actProducto} autoComplete="off"/>
							</div>
						</div>

						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>Sobrepedido:</label>
								<Switch color="primary" onChange={()=>toggleBool('sobrepedido')} checked={boolVal(datos.sobrepedido)} />
								<label className={`form-label`}>{boolVal(datos.sobrepedido)?'Si':'No'}</label>
							</div>
						</div>
						<div className="col-sm-12 col-md-4" style={{ display: shouldShowDiasPedido ? 'block' : 'none' }}>
							<div className="form-group">
								<label className={`form-label`}>Dias de pedido</label>
								<input
									name="dias_pedido"
									value={datos.dias_pedido ?? datos.dias ?? ''}
									className="form-control"
									type="text"
									onChange={actProducto}
									autoComplete="off"
								/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4" style={{ display: precioActivo ? 'block' : 'none' }}>
							<div className="form-group">
								<label className={`form-label`}>Precio (máx. 2 decimales)</label>
								<input
									name="price"
									value={datos.price || ''}
									className="form-control"
									type="text"
									onChange={handlePrecioChange}
									autoComplete="off"
									placeholder="0.00"
								/>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>Precio:</label>
								<Switch color="primary" onChange={()=>{
									const newValue = !precioActivo;
									setPrecioActivo(newValue);
									setDatos(prev => ({ ...prev, PRECIO_ACTIVO: newValue }));
								}} checked={precioActivo} />
								<label className={`form-label`}>{precioActivo?'Si':'No'}</label>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>Destacado:</label>
								<Switch color="primary" onChange={()=>toggleBool('destacado')} checked={boolVal(datos.destacado)} />
								<label className={`form-label`}>{boolVal(datos.destacado)?'Si':'No'}</label>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>Visible:</label>
								<Switch color="primary" onChange={()=>toggleBool('visible')} checked={boolVal(datos.visible)} />
								<label className={`form-label`}>{boolVal(datos.visible)?'Si':'No'}</label>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>Sustitutos:</label>
								<Switch color="primary" onChange={()=>setSustitutosActivo(prev => !prev)} checked={sustitutosActivo} />
								<label className={`form-label`}>{boolVal(datos.sustitutos)?'Si':'No'}</label>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>{getNombreNivel(1)}:</label>
								<Switch color="primary" onChange={()=>toggleBool('NIVEL_1')} checked={boolVal(datos.NIVEL_1)} />
								<label className={`form-label`}>{boolVal(datos.NIVEL_1)?'Si':'No'}</label>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="form-group mt-4 text-center shadow shadow-showcase p-1">
								<label className={`form-label mb-0`}>{getNombreNivel(2)}:</label>
								<Switch color="primary" onChange={()=>toggleBool('NIVEL_2')} checked={boolVal(datos.NIVEL_2)} />
								<label className={`form-label`}>{boolVal(datos.NIVEL_2)?'Si':'No'}</label>
							</div>
						</div>

                        {showSustitutosTable && (
                        <div className="container-fluid p-3 pt-5">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <div className="input-group bg-white rounded" style={{ boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.154)'}}>
                                        <input
                                            type="text"
                                            className="form-control border-0"
                                            placeholder="Buscar productos..."
                                            value={filtroTexto}
                                            onChange={(e) => setFiltroTexto(e.target.value)}
                                        />
                                        <span className="input-group-text bg-white border-0 text-muted">
                                            <i className="fa fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <select
                                        style={{ boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.154)', padding: '9px'}}
                                        className="form-select px-5 w-100 border-0 text-muted"
                                        value={filtroDepartamento}
                                        onChange={(e) => setFiltroDepartamento(e.target.value)}
                                    >
                                        <option value="">Departamento</option>
                                        {departamentosDisponibles.map(dep => (
                                            <option key={dep} value={dep}>{dep}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <select
                                        style={{ boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.154)', padding: '9px'}}
                                        className="form-select px-5 w-100 border-0 text-muted"
                                        value={filtroSubdepartamento}
                                        onChange={(e) => setFiltroSubdepartamento(e.target.value)}
                                    >
                                        <option value="">Subdepartamento</option>
                                        {subdepartamentosDisponibles.map(sub => (
                                            <option key={sub} value={sub}>{sub}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-8">
                                    <div className="card shadow-sm border-0">
                                        <div className="table-responsive">
                                            <table className="table mb-0 align-middle text-center">
                                                <thead style={{ backgroundColor: '#e7e7e7'}}>
                                                    <tr>
                                                        <th className="text-muted small">Sku</th>
                                                        <th className="text-muted small">Nombre</th>
                                                        <th className="text-muted small">Marca</th>
                                                        <th className="text-muted small">Unidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {productosPaginados.map((prod, index) => {
                                                        const sku = getSku(prod);
                                                        const nombre = getNombre(prod);
                                                        const marca = getMarca(prod);
                                                        const unidad = getUnidad(prod);
                                                        const seleccionado = sustitutosGuardados.some(item => String(item) === String(sku));
                                                        return (
                                                            <tr
                                                                key={String(sku) || index}
                                                                onClick={() => toggleSustituto(prod)}
                                                                style={{ cursor: 'pointer', backgroundColor: seleccionado ? '#f0f2ff' : 'transparent' }}
                                                            >
                                                                <td className="fw-bold">{sku || '-'}</td>
                                                                <td className="fw-bold">{nombre || '-'}</td>
                                                                <td className="fw-bold">{marca || '-'}</td>
                                                                <td className="fw-bold">{unidad || '-'}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    
                                    <div className="card-footer bg-white border-0 d-flex justify-content-end pb-3">
                                            <div className="btn-group shadow-sm">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm px-3"
                                                    style={{backgroundColor: '#6868C8', color: '#fff', borderRadius: '4px'}}
                                                    onClick={() => setPagina(1)}
                                                    disabled={paginaActiva === 1}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11 7l-5 5l5 5" /><path d="M17 7l-5 5l5 5" /></svg>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm px-3 mx-2"
                                                    style={{backgroundColor: '#000082', color: '#fff', borderRadius: '4px'}}
                                                    onClick={() => setPagina(Math.max(1, paginaActiva - 1))}
                                                    disabled={paginaActiva === 1}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6" /></svg>
                                                </button>
                                                <button className="btn btn-sm px-3" style={{backgroundColor: '#000C3D', color: '#fff', borderRadius: '4px'}}>{paginaActiva}</button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm px-3 mx-2"
                                                    style={{backgroundColor: '#000082', color: '#fff', borderRadius: '4px'}}
                                                    onClick={() => setPagina(Math.min(totalPaginas, paginaActiva + 1))}
                                                    disabled={paginaActiva >= totalPaginas}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" /></svg>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm px-3"
                                                    style={{backgroundColor: '#000082', color: '#fff', borderRadius: '4px'}}
                                                    onClick={() => setPagina(totalPaginas)}
                                                    disabled={paginaActiva >= totalPaginas}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-chevrons-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7l5 5l-5 5" /><path d="M13 7l5 5l-5 5" /></svg>
                                                </button>
                                            </div>
                                        </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="card shadow-sm border-0 h-100">
                                        <div className="card-header bg-white border-0 py-1">
                                            <h6 className="fw-bold pt-1" style={{color: 'black'}}>Lista de sustitutos</h6>
                                        </div>
                                        <div className="card-body p-0">
                                            <ul className="list-group list-group-flush small" style={{ borderTop: '1px solid #d0d0d0', borderBottom: '1px solid #d0d0d0'}}>
                                                {selectedSustitutos.length ? selectedSustitutos.map((item, idx) => (
                                                    <li
                                                        key={`${item.sku}-${idx}`}
                                                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                                        onClick={() => toggleSustituto(item)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <span>{item.name || item.sku} ({item.sku})</span>
                                                        <Check size={16} color="#000082" />
                                                    </li>
                                                )) : (
                                                    <li className="list-group-item text-muted">Sin sustitutos seleccionados</li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                        <div className="col-md-12 mt-3">


						<hr className="mt-2"/>

						<h4 className="mt-3 mb-4 ml-4"><strong>{!actualizar ? 'Agregar' : 'Actualizar'} fotos</strong></h4>

						<div className="row mb-4">

							<div className="col-md-12">

								<div className="row justify-content-center mt-3">

									<div className="col-4 text-center">

										<i className="ti-image" style={{ color: '#E91E63', fontSize: '24px' }}></i>

										<h3 className="mb-0" style={{ color: '#000082', fontSize: '18px', fontWeight: 'bold' }}>Formatos requeridos:</h3>

										<p className="mb-0" style={{ fontSize: '14px' }}>.PNG, .JPG</p>

									</div>

									<div className="col-4 text-center">

										<i className="ti-control-forward" style={{ color: '#E91E63', fontSize: '24px' }}></i>

										<h3 className="mb-0" style={{ color: '#000082', fontSize: '18px', fontWeight: 'bold' }}>Medidas recomendadas:</h3>

										<p className="mb-0" style={{ fontSize: '14px' }}>235 x 234 px</p>

									</div>

									<div className="col-4 text-center">

										<i className="ti-video-camera" style={{ color: '#E91E63', fontSize: '24px' }}></i>

										<h3 className="mb-0" style={{ color: '#000082', fontSize: '18px', fontWeight: 'bold' }}>Peso requerido:</h3>

										<p className="mb-0" style={{ fontSize: '14px' }}>Maximo 80 kb</p>

									</div>

								</div>

							</div>

						</div>

						<div

							style={styles.dropzone}

							onDragOver={(e) => e.preventDefault()}

							onDrop={(e) => onDrop(portadaSlot.order, e)}

							onClick={() => openFileDialog(portadaSlot.order)}

						>

                            {renderDeleteButton(portadaSlot)}

							<input

								type="file"

								ref={el => { fileInputRefs.current[portadaSlot.order] = el }}

								style={{ display: 'none' }}

								accept="image/png, image/jpeg"

								onChange={(e) => handleFile(portadaSlot.order, e.target.files[0])}

							/>

							{portadaSlot.preview ? (

								<img src={portadaSlot.preview} alt="Vista previa" style={{ maxHeight: '150px', borderRadius: '8px' }} />

							) : (

								<Fragment>

									<svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="#000082" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icon-tabler-photo">

										<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 8h.01" /><path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z" /><path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5" />

										<path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3" />

									</svg>

									<p className="mt-3 mb-0" style={{ fontWeight: '600', color: '#000082', fontSize: '20px' }}>{portadaSlot.label}</p>

								</Fragment>

							)}

						</div>

					</div>

					<div className="col-md-12 d-flex mt-3" style={{ gap: "20px", flexWrap: "wrap" }}>

						{detalleSlots.map(slot => (

							<div

								key={slot.order}

								style={styles.dropzoneMiniatura}

								onDragOver={(e) => e.preventDefault()}

								onDrop={(e) => onDrop(slot.order, e)}

								onClick={() => openFileDialog(slot.order)}

							>

                                {renderDeleteButton(slot)}

								<input

									type="file"

									ref={el => { fileInputRefs.current[slot.order] = el }}

									style={{ display: 'none' }}

									accept="image/png, image/jpeg"

									onChange={(e) => handleFile(slot.order, e.target.files[0])}

								/>

								{slot.preview ? (

									<img src={slot.preview} alt="Vista previa" style={{ maxHeight: '150px', borderRadius: '8px' }} />

								) : (

									<Fragment>

										<svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="#000082" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icon-tabler-slideshow">

											<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l.01 0" /><path d="M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z" /><path d="M3 13l4 -4a3 5 0 0 1 3 0l4 4" /><path d="M13 12l2 -2a3 5 0 0 1 3 0l3 3" />

											<path d="M8 21l.01 0" /><path d="M12 21l.01 0" /><path d="M16 21l.01 0" />

										</svg>

										<p className="mt-3 mb-0" style={{ fontWeight: '600', color: '#000082', fontSize: '20px' }}>{slot.label}</p>

									</Fragment>

								)}

							</div>

						))}

					</div>
				</div>
			</div>
	</Fragment>
	);
}

export default FormularioProducto;
